module.exports = __webpack_public_path__ + "static/media/organice.11553f69.svg";